import { mainAPI, handleApiError } from "../api";
import { FeedbackStatusUpdateRequest } from "../types/api/feedback";
import { ApiErrorResponse } from "../types/api/error";
import {
  UserSuggestionResponse,
  UserSuggestionsRequest,
} from "../types/api/userSuggestions";

const path = `/feedback/admin/${process.env.REACT_APP_API_VERSION}/proposals`;

export function fetchUserSuggestions(params: UserSuggestionsRequest = {}) {
  return mainAPI
    .get<UserSuggestionResponse[]>(`${path}`, {
      params: params,
    })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}

// Предложения - Изменить статус
export function updateUserSuggestionsStatus(data: FeedbackStatusUpdateRequest) {
  return mainAPI.post(`${path}/status`, data).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}
